import { ComponentPropsWithoutRef, ElementType, ReactNode, Ref } from 'react';
import { useFela } from 'react-fela';
import { FelaExtend } from '../../../types/fela';

type ViewProps = {
  children?: ReactNode;
  className?: string;
  innerRef?: Ref<unknown> | null;
  as?: ElementType;
  extend?: FelaExtend;
} & Record<string, unknown>;

const defaultStyle = {
  display: 'block',
};

const View = ({
  children,
  className,
  innerRef = null,
  as: As = 'div',
  extend,
  ...props
}: ViewProps) => {
  const { css } = useFela(props);

  return (
    <As
      {...(props as ComponentPropsWithoutRef<ElementType>)}
      ref={innerRef}
      className={css(defaultStyle, extend as object) + (className ? ' ' + className : '')}
    >
      {children}
    </As>
  );
};

export default View;
